// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { defaultRangeExtractor } from '../../vendor/react-virtual';
export default function (range) {
    const defaultRange = defaultRangeExtractor(range);
    return defaultRange[0] === 0 ? defaultRange : [0, ...defaultRange];
}
//# sourceMappingURL=sticky-range-extractor.js.map